import getConfig from 'next/config';
import Cookies from 'universal-cookie';

import { isHttps } from 'utils/url';

export function parseValue(value: string): any {
    return typeof value === 'undefined' || value === 'undefined' || value === 'null' ? null : value;
}

export function getProvider(): any {
    const core = new Cookies('');

    return {
        get: (name: string) : string => {
            return parseValue(core.get(name));
        },
        set: (name: string, value: string, options = {}): void => {
            return core.set(name, value, { ...getDefaultOptions(), ...parseOptions(options) });
        },
        remove: (name: string): void => {
            return core.remove(name, { path: getDefaultOptions().path, domain: getDefaultOptions().domain });
        },
    };
}

function getDefaultOptions():any {
    const { publicRuntimeConfig } = getConfig();

    let settings: any = {
        path: '/',
        expires: getDefaultExpireDate(),
        secure: isHttps(),
    };

    if(publicRuntimeConfig.COOKIE_DOMAIN) {
        settings = {
            ...settings,
            domain: publicRuntimeConfig.COOKIE_DOMAIN,
        };
    }

    return settings;
}

function parseOptions(options) {
    return {
        ...options,
        expires: options.session ?
            getSessionExpireDate()
            :
            options.expires ? options.expires : getDefaultExpireDate(),
    };
}

function getDefaultExpireDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(year + 99, month, day);
}

function getSessionExpireDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(year, month, day - 1);
}
